import { render, staticRenderFns } from "./RotationDesktop.vue?vue&type=template&id=3632968e&scoped=true&"
import script from "./RotationDesktop.vue?vue&type=script&lang=ts&"
export * from "./RotationDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./RotationDesktop.vue?vue&type=style&index=0&id=3632968e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3632968e",
  null
  
)

export default component.exports